import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import SponsorsPartners from 'components/NextconLabSponsorsPartners/SponsorsPartners';
import { useEffect } from "react";

function FsponsorsPartners() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <SponsorsPartners/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <SponsorsPartners/>
        <Footer />
      </>
    )}
    </>
  );
}

export default FsponsorsPartners;
